import * as yup from 'yup';

const cyrillicRegex = /^[А-Яа-яЁё\s-]+$/;

export const firstStepValidationSchema = yup.object().shape({
  applicantLastName: yup
    .string()
    .required('Неверный формат данных')
    .test('cyrillic', 'Неверный формат данных', (value: string) => {
      if (!value || value.trim() === '') return false;

      return cyrillicRegex.test(value);
    }),
  applicantFirstName: yup
    .string()
    .required('Неверный формат данных')
    .test('cyrillic', 'Неверный формат данных', (value: string) => {
      if (!value || value.trim() === '') return false;

      return cyrillicRegex.test(value);
    }),
  applicantMiddleName: yup
    .string()
    .required('Неверный формат данных')
    .test('cyrillic', 'Неверный формат данных', (value: string) => {
      if (!value || value.trim() === '') return false;

      return cyrillicRegex.test(value);
    }),
  phone: yup
    .string()
    .required('Неверный формат данных')
    .test('phone', 'Введите корректный номер телефона', (value: string) => {
      const digits = value.replace(/\D/g, '');

      if (digits.length === 11) return true;
      if (digits.length === 12 && (digits.startsWith('7') || digits.startsWith('8'))) return true;

      return false;
    }),
  consentProcessingPersonalData: yup
    .boolean()
    .oneOf([true], 'Данный пункт является обязательным')
    .required('Данный пункт является обязательным'),
  consentInclusionPersonnelReserve: yup.boolean(),
});

export const secondStepValidationSchema = yup.object().shape({
  phone: yup.string().optional(),
  verificationCode: yup
    .string()
    .required('Неверный формат данных')
    .test('verificationCode', 'Значение должно состоять из 4 цифр', (value: string) => {
      const digits = value.replace(/\D/g, '');

      if (digits.length === 4) return true;

      return false;
    }),
});
